module.exports = __webpack_public_path__ + "img/firstSide.32063361.svg";